import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64d617ee")

_pushScopeId("data-v-64d617ee")
const _hoisted_1 = { class: "flex flex-row items-center justify-between p-4" }
const _hoisted_2 = { class: "flex flex-row items-start justify-start gap-x-5" }
const _hoisted_3 = { class: "flex flex-col justify-end gap-x-2" }
const _hoisted_4 = { class: "text-xl font-bold flight-main-text-color" }
const _hoisted_5 = { class: "text-xs font-normal flight-sub-text-color" }
const _hoisted_6 = {
  class: "flex flex-col items-center justify-center gap-y-1.5",
  style: {"min-width":"407px"}
}
const _hoisted_7 = { class: "flex flex-row items-center justify-between w-full flight-main-text-color" }
const _hoisted_8 = { class: "text-xs" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" • ")
const _hoisted_10 = { class: "flight-sub-text-color" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center w-full" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "flight-line-main",
    style: {"height":"2px","width":"40px"}
  }),
  /*#__PURE__*/_createVNode("div", {
    class: "flight-line-default w-full",
    style: {"height":"2px"}
  }),
  /*#__PURE__*/_createVNode("div", {
    class: "flight-line-main",
    style: {"height":"2px","width":"40px"}
  })
], -1)
const _hoisted_12 = { class: "flex flex-row items-center justify-between w-full flight-main-text-color" }
const _hoisted_13 = { class: "text-sm font-semibold flight-main-text-color" }
const _hoisted_14 = { class: "flex items-center gap-x-2 text-sm font-semibold flight-main-text-color" }
const _hoisted_15 = { class: "text-sm font-semibold flight-main-text-color" }
const _hoisted_16 = { class: "flex flex-col justify-end gap-x-2" }
const _hoisted_17 = { class: "text-xl font-bold flight-main-text-color relative" }
const _hoisted_18 = {
  key: 0,
  class: "absolute top-0 right-0 text-sm flight-diff-text-color font-bold",
  style: {"transform":"translate(105%, -25%)"}
}
const _hoisted_19 = { class: "text-xs font-normal flight-sub-text-color" }
const _hoisted_20 = {
  key: 0,
  class: "py-2 px-4"
}
const _hoisted_21 = { class: "text-xs font-semibold" }
const _hoisted_22 = {
  key: 0,
  class: "w-full bg-gray-lp-2800 p-2 flex flex-row items-center justify-center gap-1 rounded-xl"
}
const _hoisted_23 = {
  key: 0,
  class: "text-xs flight-sub-text-color whitespace-nowrap"
}
const _hoisted_24 = {
  key: 1,
  class: "text-xs flight-sub-text-color whitespace-nowrap"
}
const _hoisted_25 = { class: "text-xs flight-main-text-color flex flex-row items-center gap-x-1" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", {
  class: "bg-gray-lp-1300",
  style: {"width":"1px","height":"12px"}
}, null, -1)
const _hoisted_27 = { class: "text-xs text-gray-lp-800 flex flex-row items-center gap-x-2.5" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  class: "text-normal flight-main-text-color",
  style: {"font-weight":"900"}
}
const _hoisted_30 = { class: "w-full flex-col justify-center items-center" }
const _hoisted_31 = { class: "w-full flex flex-row items-center gap-x-1" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", {
  class: "bg-gray-lp-1300 w-full",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_33 = { class: "text-normal font-bold text-black-lp-100 flex flex-row items-center gap-x-1 flex-shrink-0" }
const _hoisted_34 = { class: "whitespace-nowrap" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", {
  class: "bg-gray-lp-1300 w-full",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_36 = {
  key: 0,
  class: "px-2 flex flex-col justify-center items-center"
}
const _hoisted_37 = { class: "text-xs flight-sub-text-color whitespace-nowrap" }
const _hoisted_38 = { class: "text-xs flight-main-text-color flex flex-row items-center gap-x-1" }
const _hoisted_39 = { class: "text-xs text-gray-lp-800 flex flex-row items-center gap-x-1" }
const _hoisted_40 = {
  class: "text-normal flight-main-text-color",
  style: {"font-weight":"900"}
}
const _hoisted_41 = {
  key: 1,
  class: "w-full flex flex-col overflow-hidden"
}
const _hoisted_42 = {
  key: 1,
  class: "px-2 flex flex-col justify-center items-center",
  style: {"width":"max-content"}
}
const _hoisted_43 = { class: "text-xs flight-sub-text-color whitespace-nowrap" }
const _hoisted_44 = { class: "text-xs flight-main-text-color flex flex-row items-center gap-x-1" }
const _hoisted_45 = { class: "text-xs text-gray-lp-800" }
const _hoisted_46 = {
  class: "text-normal flight-main-text-color",
  style: {"font-weight":"900"}
}
const _hoisted_47 = { class: "flex flex-col justify-center items-center px-2 flex-shrink-0" }
const _hoisted_48 = {
  key: 0,
  class: "text-xs flight-sub-text-color whitespace-nowrap"
}
const _hoisted_49 = {
  key: 1,
  class: "text-xs flight-sub-text-color whitespace-nowrap"
}
const _hoisted_50 = { class: "text-xs flight-main-text-color flex flex-row items-center gap-x-1" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", {
  class: "bg-gray-lp-1300",
  style: {"width":"1px","height":"12px"}
}, null, -1)
const _hoisted_52 = { class: "text-xs text-gray-lp-800 flex flex-row items-center gap-x-2.5" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = {
  class: "text-normal flight-main-text-color",
  style: {"font-weight":"900"}
}
const _hoisted_55 = { class: "flex-1 flex flex-col justify-center items-center min-w-0" }
const _hoisted_56 = { class: "w-full flex flex-row items-center gap-x-1" }
const _hoisted_57 = /*#__PURE__*/_createVNode("div", {
  class: "bg-gray-lp-1300 flex-1",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_58 = { class: "text-normal font-bold text-black-lp-100 flex flex-row items-center gap-x-1 flex-shrink-0" }
const _hoisted_59 = { class: "whitespace-nowrap" }
const _hoisted_60 = {
  class: "bg-gray-lp-1300 flex-1 text-gray-lp-1300 relative",
  style: {"height":"1px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("button", {
    class: "card-search-flight w-full rounded-xl flight-border-color",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleTransit && _ctx.toggleTransit(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.formatTime(_ctx.flight?.itineraries?.[0]?.departureDate)), 1),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.formatDateShort(_ctx.flight?.itineraries?.[0]?.departureDate)), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_Icons, {
              name: "plane-departure",
              style: {"width":"14px","height":"14px"}
            }),
            _createVNode("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.formatDuration(_ctx.flight.totalTravelTimeMin)) + " ", 1),
              (_ctx.flight.totalLeg > 1)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_9,
                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.transitLabel), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_Icons, {
              name: "plane-arrival",
              style: {"width":"14px","height":"14px"}
            })
          ]),
          _hoisted_11,
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.flight?.itineraries?.[0]?.originAirportCode || "-"), 1),
            _createVNode("div", _hoisted_14, [
              _createVNode("img", {
                src: _ctx.flightIcon(_ctx.firstFlightNo),
                alt: "flight-icon",
                style: {"width":"32px","height":"32px"}
              }, null, 8, ["src"]),
              _createTextVNode(" " + _toDisplayString(_ctx.firstFlightNo), 1)
            ]),
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.flight?.itineraries?.[_ctx.flight?.itineraries?.length-1]?.destinationAirportCode || "-"), 1)
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.formatTime(_ctx.flight?.itineraries?.[_ctx.flight?.itineraries?.length-1]?.arrivalDate || "")) + " ", 1),
            (_ctx.arrivalDayDiff > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.arrivalDayDiff", { count: _ctx.arrivalDayDiff })), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_19, _toDisplayString(_ctx.formatDateShort(_ctx.flight?.itineraries?.[_ctx.flight?.itineraries?.length-1]?.arrivalDate || "")), 1)
        ])
      ]),
      (_ctx.flight.itineraries.length > 1)
        ? (_openBlock(), _createBlock("div", _hoisted_20, [
            _createVNode("span", _hoisted_21, _toDisplayString(!_ctx.isTransitOpen ? _ctx.$t("cargoV2.components.cardFlight.viewTransitDetail") : _ctx.$t("cargoV2.components.cardFlight.close")), 1),
            _createVNode(_component_Icons, {
              name: "chevron-down-new",
              style: [{"width":"20px","height":"20px"}, {
            transform: _ctx.isTransitOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease-in-out',
          }]
            }, null, 8, ["style"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isTransitOpen && !_ctx.isGridLayout)
      ? (_openBlock(), _createBlock("div", _hoisted_22, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.flight.itineraries, (transit, index) => {
            return (_openBlock(), _createBlock("div", {
              key: transit.departureDate,
              class: "flex flex-row items-center gap-1 flex-grow rounded-xl"
            }, [
              _createVNode("div", {
                class: ["flex flex-col justify-center items-center", { 'px-2': index === 0 }]
              }, [
                (index === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_23, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.originCity")), 1))
                  : (_openBlock(), _createBlock("div", _hoisted_24, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.transit", { count: index })), 1)),
                _createVNode("div", _hoisted_25, [
                  (index > 0)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_Icons, {
                          name: "plane-arrival",
                          style: {"width":"8px","height":"8px"}
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.flight.itineraries[index-1].arrivalDate || "")) + " ", 1),
                        _hoisted_26
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatTime(transit.departureDate)) + " ", 1),
                  _createVNode(_component_Icons, {
                    name: "plane-departure",
                    style: {"width":"8px","height":"8px"}
                  })
                ]),
                _createVNode("div", _hoisted_27, [
                  (index > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_28, _toDisplayString(_ctx.formatDateTransit(_ctx.flight.itineraries[index-1].arrivalDate || "")), 1))
                    : _createCommentVNode("", true),
                  _createVNode("div", null, _toDisplayString(_ctx.formatDateTransit(transit.departureDate)), 1)
                ]),
                _createVNode("div", _hoisted_29, _toDisplayString(transit.originAirportCode), 1)
              ], 2),
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createVNode("div", _hoisted_33, [
                    _createVNode("img", {
                      src: _ctx.flightIcon(transit.flightNo),
                      alt: "flight-icon",
                      style: {"width":"32px","height":"32px"}
                    }, null, 8, ["src"]),
                    _createVNode("span", _hoisted_34, _toDisplayString(transit.flightNo), 1)
                  ]),
                  _hoisted_35
                ])
              ]),
              (index === _ctx.flight.itineraries.length - 1)
                ? (_openBlock(), _createBlock("div", _hoisted_36, [
                    _createVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.destinationCity")), 1),
                    _createVNode("div", _hoisted_38, [
                      _createVNode(_component_Icons, {
                        name: "plane-arrival",
                        style: {"width":"8px","height":"8px"}
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.formatTime(transit.arrivalDate)), 1)
                    ]),
                    _createVNode("div", _hoisted_39, _toDisplayString(_ctx.formatDateTransit(transit.arrivalDate)), 1),
                    _createVNode("div", _hoisted_40, _toDisplayString(transit.destinationAirportCode), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isTransitOpen && _ctx.isGridLayout)
      ? (_openBlock(), _createBlock("div", _hoisted_41, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transitGridRows, (row, rowIndex) => {
            return (_openBlock(), _createBlock("div", {
              key: rowIndex,
              class: ["flex flex-row items-center gap-1 p-2", rowIndex % 2 === 0 ? 'bg-gray-lp-2800' : 'bg-white']
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(row, (item, itemIndex) => {
                return (_openBlock(), _createBlock("div", {
                  key: itemIndex,
                  class: "flex flex-row items-center gap-1 flex-1"
                }, [
                  (item.isEmpty)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [], 64))
                    : (item.isDestination)
                      ? (_openBlock(), _createBlock("div", _hoisted_42, [
                          _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.destinationCity")), 1),
                          _createVNode("div", _hoisted_44, [
                            _createVNode(_component_Icons, {
                              name: "plane-arrival",
                              style: {"width":"8px","height":"8px"}
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.formatTime(item.transit.arrivalDate)), 1)
                          ]),
                          _createVNode("div", _hoisted_45, _toDisplayString(_ctx.formatDateTransit(item.transit.arrivalDate)), 1),
                          _createVNode("div", _hoisted_46, _toDisplayString(item.transit.destinationAirportCode), 1)
                        ]))
                      : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                          _createVNode("div", _hoisted_47, [
                            (item.index === 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_48, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.originCity")), 1))
                              : (_openBlock(), _createBlock("div", _hoisted_49, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.transit", { count: item.index })), 1)),
                            _createVNode("div", _hoisted_50, [
                              (item.index > 0)
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_Icons, {
                                      name: "plane-arrival",
                                      style: {"width":"8px","height":"8px"}
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.flight.itineraries[item.index - 1].arrivalDate || "")) + " ", 1),
                                    _hoisted_51
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_ctx.formatTime(item.transit.departureDate)) + " ", 1),
                              _createVNode(_component_Icons, {
                                name: "plane-departure",
                                style: {"width":"8px","height":"8px"}
                              })
                            ]),
                            _createVNode("div", _hoisted_52, [
                              (item.index > 0)
                                ? (_openBlock(), _createBlock("div", _hoisted_53, _toDisplayString(_ctx.formatDateTransit(_ctx.flight.itineraries[item.index - 1].arrivalDate || "")), 1))
                                : _createCommentVNode("", true),
                              _createVNode("div", null, _toDisplayString(_ctx.formatDateTransit(item.transit.departureDate)), 1)
                            ]),
                            _createVNode("div", _hoisted_54, _toDisplayString(item.transit.originAirportCode), 1)
                          ]),
                          _createVNode("div", _hoisted_55, [
                            _createVNode("div", _hoisted_56, [
                              _hoisted_57,
                              _createVNode("div", _hoisted_58, [
                                _createVNode("img", {
                                  src: _ctx.flightIcon(item.transit.flightNo),
                                  alt: "flight-icon",
                                  style: {"width":"32px","height":"32px"}
                                }, null, 8, ["src"]),
                                _createVNode("span", _hoisted_59, _toDisplayString(item.transit.flightNo), 1)
                              ]),
                              _createVNode("div", _hoisted_60, [
                                _createVNode(_component_Icons, {
                                  name: "arrow-up",
                                  style: {"transform":"rotate(90deg)","position":"absolute","top":"-4.5","right":"-2","width":"10px","height":"10px"}
                                })
                              ])
                            ])
                          ])
                        ], 64))
                ]))
              }), 128))
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
})